import { outlinedInputClasses } from '@mui/material'
import StylesPhoneInputServiceInterface
  from '~/src/components/mui-wrappers/styled/phone-input/styles/StylesPhoneInputServiceInterface'
import TemplateServiceStyleBase from '~/src/utils/template/TemplateServiceStyleBase'

export default class StylesPhoneInputServiceStyleTwo extends TemplateServiceStyleBase implements StylesPhoneInputServiceInterface {
  public getComponentSx(): Record<string, unknown> {
    return {
      [`.${outlinedInputClasses.root}`]: {
        borderRadius: '.5em',
        backgroundColor: this.muiTheme.palette.getContrastText(this.muiTheme.palette.text.primary)
      },
      '& > p': {
        textAlign: 'right'
      }
    }
  }
}
